<template>
  <div class="card-list">
    <div class="loading" v-show="loading">
        <van-loading class="loading-icon" color="#E33D72" vertical>加载中...</van-loading>
    </div>
    <div v-show="!loading">
        <div class="card" v-for="item in dataList" :key="item.id">
            <div class="card-info" @click="toPage('SakuraBoxDetailApp', item.id)">
                <div class="card-img">
                    <img :src="item.sm_image +'?imageView2/3/w/292/h/168'" alt="">
                </div>
                <div class="card-desc">
                    <div class="card-title ellipsis">{{item.title}}</div>
                    <div class="card-user ellipsis">
                        <img :src="item.avatar" alt="">
                        {{item.nickname}}
                    </div>
                    <div class="card-user-sign">{{item.intro}}</div>
                </div>
            </div>
            <div class="card-tag">
                存档标签
                <span v-for="tag in item.tags" :key="tag.id">{{tag.name}}</span>
            </div>
            <div class="card-btn-box">
                <img @click="copyRecordId(item.game_arc_id, item.id)" src="@/assets/sakuraBox/card-btn-copy.png" class="card-btn active copyName">
                <img @click="toPage('SakuraBoxDetailApp', item.id)" src="@/assets/sakuraBox/card-btn-detail.png" class="card-btn active">
            </div>
        </div>
        <div class="no-recard" v-if="dataList.length === 0">
            <img src="@/assets/sakuraBox/no-record.png" alt="">
            {{cardType === 3 ? '你还没有任何收藏，快去看看吧' : '暂无数据'}}
        </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import { mapState } from "vuex";
export default {
  props:["cardType","dataList","loading"],
  components: {

  },
  data() {
    return {
        status: 1,
    }
  },
  computed:{
    ...mapState([
      "isGuest"
    ]),
  },
  mounted(){
  },
  methods:{
    // 复制存档ID
    copyRecordId(code, id) {
        this.$tea('event_sakura_box_arc_op_click',{ sakura_arc_id: id, sakura_op: 4, source: 'sakuraBoxApp' }) // 单个存档的分享次数、点赞次数、收藏次数、复制ID次数
        let clipboard = new Clipboard('.copyName', {
            text: function () {
                return code
            }
        });
        clipboard.on('success', e => {
            this.$toast('已复制到剪切板');
            // 释放内存
            clipboard.destroy();
        });
        clipboard.on('error', e => {
            this.$toast('复制失败');
            clipboard.destroy();
        });
    },
    toPage(name, arc_id){
      this.$router.push({
          name,
          params: {
              arc_id: arc_id
          }
      });
    },
    openPanel(id){
        this.$emit('openPanel', 1 , id)
    },
  }
}
</script>

<style scoped>
    .ellipsis{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .card-list{
        padding-top: 15px;
        width: 326px;
        margin: 0 auto;
    }
    .card{
        width: 100%;
        background: white;
        border-radius: 10px;
        border:solid 1px #FA7CB5;
        padding: 13px 13px 0 13px;
        margin-bottom: 0.14rem;
    }
    .card-img, .card-desc{
        display: inline-block;
    }
    .card-img{
        width: 146px;
        height: 84px;
        border-radius: 10px;
        overflow: hidden;
    }
    .card-img img{
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
    }
    .card-desc{
        width: 138px;
        height: 85px;
        overflow: hidden;
        margin-left: 13px;
    }
    .card-title{
        font-size: 15px;
        font-weight: 500;
        color: #383838;
    }
    .card-user img{
        width: 23px;
        height: 23px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 9px;
    }
    .card-user{
        font-size: 13px;
        font-weight: 400;
        color: #575757;
        margin: 6px 0;
    }
    .card-user-sign{
        width: 200%;
        font-size: 20px;
        font-weight: 400;
        color: #696969;
        transform: scale(0.5) translate(-50%, -50%);
        line-height: 26px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
    }
    .card-tag{
        font-size: 13px;
        color: #757575;
        padding-left: 19px;
        background: url('~assets/sakuraBox/card-tag.png') no-repeat;
        background-size: 13px;
        background-position: top 5px left;
    }
    .card-tag span{
        display: inline-block;
        background: #FEF2F7;
        border-radius: 3px;
        padding: 0 5px;
        font-size: 12px;
        line-height: 18px;
        text-align: center;
        color: #E33D72;
        margin: 2px 3px;
        position: relative;
    }
    .card-btn{
        width: 143px;
        height: 32px;
        margin-top: 9px;
    }
    .card-btn-box{
        width: 100%;
        margin: 0 auto 0.14rem 0;
        display: flex;
        justify-content: space-between;
    }
    .card-footer{
        width: 100%;
        height: 40px;
        border-top:solid 1px RGBA(203, 203, 203, 0.5);
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .footer-btn img{
        width: 14px;
        height: 12px;
        display: inline-block;
        transform: translateY(-1px);
        margin-right: 2px;
    }
    .footer-btn{
        font-size: 12px;
        color: #555;
        transform: scale(0.85) translateX(6%);
        width: 100px;
        text-align: center;
        height: 100%;
        line-height: 40px;
    }
    .active:active{
        transform: scale(0.9);
    }
    .no-recard img{
        width: 101px;
        height: 91px;
        display: block;
        margin: 10px auto;
    }
    .no-recard{
        margin: 10px auto;
        font-size: 14px;
        font-weight: 400;
        color: #FA7CB5;
        line-height: 16px;
        text-align: center;
    }
    .card-footer-2{
        margin-top: 6px;
        padding-left: 120px;
        padding-right: 0;
        position: relative;
    }
    .btn-change-status{
        width: 124px;
        height: 27px;
        position: absolute;
        right: 0;
        top: 6px;
    }
    .btn-status{
        width: 71px;
        height: 19px;
        display: block;
        position: absolute;
        left: 0;
        top: 10px;
    }
    .loading{
      width: 100%;
      height: 240px;
      background: rgba(255, 255, 255, 0.7);
      position: relative;
    }
    .loading-icon{
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate(-50%,-50%);
    }
</style>
